import React from 'react'

import { TileContainer as Container } from './style'

export const TileContainer: React.FunctionComponent = ({ children }) => (
    <Container>{children}</Container>
)
